// ── useKalshiAccount — Auto-connect lifecycle hook (MT relay) ────
// On mount, checks the relay for stored credentials and connects if found.

import { useEffect } from 'react';
import { useAccountStore } from '../stores/accountStore';
import { useAuthStore } from '../stores/authStore';

export function useKalshiAccount(): void {
  const authStatus = useAuthStore((s) => s.status);
  const userId = useAuthStore((s) => s.user?.id);
  const orgId = useAuthStore((s) => s.user?.orgId);
  // The key-mode reply is dropped when the role changed while it was in
  // flight (accountStore's viewer key), so a role change must re-check too or
  // the account stays on "Checking…".
  const role = useAuthStore((s) => s.user?.role);

  useEffect(() => {
    if (authStatus !== 'authenticated') return;

    useAccountStore.getState().checkCredentials();

    return () => {
      useAccountStore.getState().disconnect();
      // Sign-out or a different user/org/role: the key-mode answer described the
      // previous identity. (A plain disconnect from Settings keeps it.)
      useAccountStore.getState().resetCredentialCheck();
    };
    // Cross-tab auth can replace an already-authenticated identity. Clean up
    // the old account generation before checking the new holdings scope.
  }, [authStatus, userId, orgId, role]);
}
